import React, { forwardRef } from "react";
import { InputMask, InputMaskProps } from "primereact/inputmask";
import { classNames } from "primereact/utils";
import { DashlyFieldShell } from "../shared/DashlyFieldShell";
import { DashlyControlSize, dashlyControlSizeClass } from "../shared/dashlyControlSize";
import "../shared/dashlyFormControl.scss";
import "./DashlyInputMask.scss";

export type DashlyInputMaskProps = InputMaskProps & {
    /** Control height scale. Default `md` (2.5rem). */
    controlSize?: DashlyControlSize;
    label?: React.ReactNode;
    labelInfo?: string;
    hint?: React.ReactNode;
    required?: boolean;
    containerClassName?: string;
};

const DashlyInputMask = forwardRef<InputMask, DashlyInputMaskProps>(function DashlyInputMask(
    {
        controlSize = "md",
        label,
        labelInfo,
        hint,
        required,
        containerClassName,
        className,
        id,
        ...rest
    },
    ref,
) {
    const control = (
        <div className={classNames("dashly-input-mask-wrap", dashlyControlSizeClass(controlSize))}>
            <InputMask
                ref={ref}
                id={id}
                {...rest}
                className={classNames("dashly-input-mask", "w-full", className)}
            />
        </div>
    );

    if (!label) {
        return control;
    }

    return (
        <DashlyFieldShell label={label} labelInfo={labelInfo} hint={hint} htmlFor={id} required={required} className={containerClassName}>
            {control}
        </DashlyFieldShell>
    );
});

DashlyInputMask.displayName = "DashlyInputMask";

export { DashlyInputMask };
